export const SIDEBAR_LEFT_SHOW = 'SIDEBAR_LEFT_SHOW';
export const SIDEBAR_LEFT_HIDE = 'SIDEBAR_LEFT_HIDE';

export const SIDEBAR_RIGHT_SHOW = 'SIDEBAR_RIGHT_SHOW';
export const SIDEBAR_RIGHT_HIDE = 'SIDEBAR_RIGHT_HIDE';

export const SIDEBAR_HIDE_ALL = 'SIDEBAR_HIDE_ALL';


// WEBPACK FOOTER //
// ./src/constants/sidebars.js